
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faKey } from '@fortawesome/free-solid-svg-icons';

import { Seg_Usuario_Validar_Opcion } from "../../request/MenuRequest";
import { Notificacion } from "../../components/Util/Notificacion/Notificacion.js";
import LocalStorage from '../../components/Util/LocalStorage/LocalStorage';
const localStorageObject = new LocalStorage();

class ModalSeguridad extends PureComponent {
    _isMounted = false;
    state = {
        username: '',
        password: '',
        deshabilitarAccion: false
    }

    componentDidMount() {
        this._isMounted = true;
        localStorageObject.set("UID", -1);
        localStorageObject.remove("USR");
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async autenticarOpcion() {

        const { username, password } = this.state;
        if (this.validarDatos(username, password, this.props.menuId, this.props.opcionId)) {
            this.setState({ deshabilitarAccion: true });
            const empresa_Id = this.props.empresa && this.props.empresa.Id ? this.props.empresa.Id : 0;
            const sucursal_Id = this.props.sucursal && this.props.sucursal.Id ? this.props.sucursal.Id : 0;
            let usuario_id = 0;

            const response = await Seg_Usuario_Validar_Opcion(this.props.token, this.props.menuId, this.props.opcionId, username, password, empresa_Id, sucursal_Id, this.props.activoAD);
            if (response.Exitoso) {
                this._isMounted && this.setState({ username: '', password: '' });
                localStorageObject.set("UID", response.Datos.Menu_Id);
                localStorageObject.set("USR", username);
                Notificacion.success("Acceso válido.");
                usuario_id = response.Datos.Usuario_Id;
            }
            else {
                if (response.Mensaje) {
                    localStorageObject.set("UID", -1);
                    localStorageObject.remove("USR");
                    Notificacion.error(response.Mensaje);
                }
                else {
                    localStorageObject.set("UID", -1);
                    localStorageObject.remove("USR");
                    Notificacion.error('Ocurrió un error validando los credenciales de acceso.');
                }
            }
            this.setState({ deshabilitarAccion: false });
            this.props.onActionResult(response.Exitoso, usuario_id);
        }
    }

    validarDatos = (pUsername, pPassword, pMenuId, pOpcionId) => {

        if (!pMenuId || isNaN(pMenuId) || pMenuId <= 0) {
            Notificacion.error("Un identificador de menú es requerido.");
            return false;
        }

        if (!pOpcionId || isNaN(pOpcionId) || pOpcionId <= 0) {
            Notificacion.error("Un identificador de opción de menú es requerido.");
            return false;
        }

        if (!pUsername || !pUsername.trim()) {
            Notificacion.error("Por favor ingrese un usuario.");
            return false;
        }

        if (!pPassword || !pPassword.trim()) {
            if (this.props.activoAD) { Notificacion.error("Por favor ingrese la PIN."); }
            else
                 Notificacion.error("Por favor ingrese la contraseña.");
            
            return false;  
        }

        return true;
    }

    onChangeInput = event => {
        let { name, value, maxLength } = event.currentTarget;
        if (maxLength && value && value.length > maxLength) {
            return;
        }
        this.setState({ [name]: value });
    }

    onKeyPressInput = event => {
        if (event.key === 'Enter') {
            this.autenticarOpcion();
        }
    }

    onHideModal = () => {
        this.setState({
            searchValue: '',
            selectedItem: null
        }, () => this.props.onHide());
    }

    render() {
        return <Modal show={this.props.show} onHide={this.onHideModal}>
            <Modal.Header closeButton>
                <Modal.Title>{this.props.modalTitle ? this.props.modalTitle : "Requiere Permisos"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {this.props.preContent && <div className="row"><div className="col">{this.props.preContent}</div></div>}
                <div className="row">
                    <div className="col">
                        <p>Por favor ingrese sus credenciales para acceder a esta opción</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text"><FontAwesomeIcon icon={faUser} /></span>
                            </div>
                            <input name="username"
                                type="text"
                                className="form-control"
                                placeholder="Nombre Usuario"
                                maxLength="20"
                                value={this.state.username}
                                onChange={this.onChangeInput} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text"><FontAwesomeIcon icon={faKey} /></span>
                            </div>
                            <input name="password"
                                type="password"
                                className="form-control"
                                placeholder={!this.props.activoAD ? "Contraseña":"PIN" }
                                maxLength="100"
                                value={this.state.password}
                                onChange={this.onChangeInput}
                                onKeyPress={this.onKeyPressInput}
                            />
                        </div>
                    </div>
                </div>
                {this.props.postContent && <div className="row"><div className="col">{this.props.postContent}</div></div>}
            </Modal.Body >
            <Modal.Footer>
                <div className="tooltip2">
                    <span className="tooltiptext2">{this.props.cancelButtonLabel ? this.props.cancelButtonLabel : "Cerrar"}</span>
                    <Button variant="secondary" onClick={this.onHideModal}>{this.props.cancelButtonLabel ? this.props.cancelButtonLabel : "Cerrar"}</Button></div>
                <div className="tooltip2">
                    <span className="tooltiptext2">{this.props.okButtonLabel ? this.props.okButtonLabel : "Ingresar"}</span>
                    <Button variant="primary" onClick={() => this.autenticarOpcion()} disabled={this.state.deshabilitarAccion || this.props.deshabilitarAccion || false}>{this.props.okButtonLabel ? this.props.okButtonLabel : "Ingresar"}</Button></div>
            </Modal.Footer>
        </Modal >;
    }
};

const mapStateToProps = state => {
    return {
        usuario: state.usuario,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal
    };
};

export default connect(mapStateToProps)(ModalSeguridad);
